// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media screen and (max-width: 870px) {\n.actions[data-v-c77178f0] {\r\n    display: block !important;\n}\n.actions button[data-v-c77178f0] {\r\n    margin-bottom: 10px;\n}\n}\r\n", ""]);
// Exports
module.exports = exports;
